import { defineStore } from 'pinia';
import { useAuthStore } from './auth';
import { useSetupCredentialsStore } from './setupCredentials';

export const useApiCredentialsStore = defineStore('apiCredentials', {
    state: () => ({
        apiKey: null,
        apiSecret: null,
        permissions: []
    }),
    
    getters: {
        hasCredentials: (state) => !!state.apiKey && !!state.apiSecret,
        
        getAuthHeaders: (state) => ({
            'Content-Type': 'application/json',
            'x-api-key': state.apiKey,
            'x-api-secret': state.apiSecret,
            'Authorization': `Bearer ${state.apiKey}`
        }),

        getAuthApiKey: (state) => state.apiKey,
        getAuthApiSecret: (state) => state.apiSecret
    },
    
    actions: {

        setCredentials(credentials) {
            this.apiKey = credentials.api_key;
            this.apiSecret = credentials.api_secret;
            this.permissions = credentials.permissions;
        },
        
        clearCredentials() {
            this.apiKey = null;
            this.apiSecret = null;
            this.permissions = [];
            
            // Reset altri store correlati
            const authStore = useAuthStore();
            const setupStore = useSetupCredentialsStore();
            
            authStore.removeToken();
            setupStore.resetSetup();
        }
    },
    
    persist: true
}); 